var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPharmacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.62518 13.8182C1.62518 14.3404 1.8326 14.8411 2.20182 15.2104C2.57103 15.5796 3.07179 15.787 3.59393 15.787H15.4064C15.9286 15.787 16.4293 15.5796 16.7985 15.2104C17.1678 14.8411 17.3752 14.3404 17.3752 13.8182V8.40417H1.62518V13.8182ZM3.9455 11.1464C3.9455 10.8666 4.05661 10.5984 4.25441 10.4006C4.4522 10.2028 4.72046 10.0917 5.00018 10.0917H6.68768C6.9674 10.0917 7.23567 10.2028 7.43346 10.4006C7.63125 10.5984 7.74237 10.8666 7.74237 11.1464V11.8495C7.74237 12.1292 7.63125 12.3975 7.43346 12.5953C7.23567 12.7931 6.9674 12.9042 6.68768 12.9042H5.00018C4.72046 12.9042 4.4522 12.7931 4.25441 12.5953C4.05661 12.3975 3.9455 12.1292 3.9455 11.8495V11.1464Z",
    fill: "#71CA9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4064 3.4115H3.59393C3.07179 3.4115 2.57103 3.61892 2.20182 3.98813C1.8326 4.35734 1.62518 4.8581 1.62518 5.38025V6.29431H17.3752V5.38025C17.3752 4.8581 17.1678 4.35734 16.7985 3.98813C16.4293 3.61892 15.9286 3.4115 15.4064 3.4115Z",
    fill: "#71CA9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharmacy);
export default __webpack_public_path__ + "static/media/pharmacy.831b4db6b22f094ce0e7b89a89ab5430.svg";
export { ForwardRef as ReactComponent };